import {StatusPageLayoutPreset} from "@/lib/types/statuspages.ts";

// The COMPACT and MINIMAL presets both render in the denser two-column arrangement, as opposed to
// the full-width EXPANDED layout. Classifying presets here keeps the check honest and means a new
// preset is added in one place instead of every scattered `COMPACT || MINIMAL` expression.
export const isTwoColumnLayout = (layout: StatusPageLayoutPreset): boolean =>
  layout === StatusPageLayoutPreset.COMPACT || layout === StatusPageLayoutPreset.MINIMAL;
